import Cookies from 'universal-cookie';

export function joinRoom(socket, roomName, playerName) {
    const data = { 
        roomName,
        playerName
    };

    socket.emit('joinRoomRequest', data);
}

export function joinRoomByCookie(socket) {
    const roomCookie = new Cookies().get('mdc_room');
    if(roomCookie){
        socket.emit('joinRoomByCookie', roomCookie)
    }
}

export function sendTchatMsg(socket, msg){
    socket.emit('tchat_sendMsg', msg);
}

